/**
 * ProgressCircleContainer component.
 */
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled progress circle container.
 */
const ProgressCircleContainer = styled.div<{
  margin: boolean;
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: ${Fonts['regular']};
  font-size: ${26 * Screen.widthRatio}px;
  height: ${42 * Screen.widthRatio}px;
  margin-left: ${(props) => (props.margin ? 16 : 0 * Screen.widthRatio)}px;
  width: ${42 * Screen.widthRatio}px;
`;

export default withOpacity(ProgressCircleContainer);
